/**
 * User role codes and hierarchy constants
 * These role codes are used across the entire application
 */

/**
 * User role codes
 */
export const ROLE_CODES = {
  COORDINATOR: 'COORDINATOR',
  PROPOSAL_COORDINATOR: 'PROPOSAL_COORDINATOR',
  HEAD_OF_DEPARTMENT: 'HEAD_OF_DEPARTMENT',
  REGIONAL_MANAGER: 'REGIONAL_MANAGER',
  C_LEVEL: 'C_LEVEL',
  APP_ADMIN: 'APP_ADMIN',
};

/**
 * Display labels for user roles
 */
export const ROLE_LABELS = {
  [ROLE_CODES.COORDINATOR]: 'Coordinator',
  [ROLE_CODES.PROPOSAL_COORDINATOR]: 'Proposal Coordinator',
  [ROLE_CODES.HEAD_OF_DEPARTMENT]: 'Head of Department',
  [ROLE_CODES.REGIONAL_MANAGER]: 'Operations Manager',
  [ROLE_CODES.C_LEVEL]: 'Chief Officer',
  [ROLE_CODES.APP_ADMIN]: 'Application Administrator',
};

/**
 * Hierarchical order of user roles (lower number = higher in hierarchy)
 */
export const ROLE_HIERARCHY = {
  [ROLE_CODES.COORDINATOR]: 1,
  [ROLE_CODES.PROPOSAL_COORDINATOR]: 2,
  [ROLE_CODES.HEAD_OF_DEPARTMENT]: 3,
  [ROLE_CODES.REGIONAL_MANAGER]: 4,
  [ROLE_CODES.C_LEVEL]: 5,
  // [ROLE_CODES.APP_ADMIN]: 100,
};
